import { render, staticRenderFns } from "./DetalleOdtPaciente.vue?vue&type=template&id=74167546"
import script from "./DetalleOdtPaciente.vue?vue&type=script&lang=js"
export * from "./DetalleOdtPaciente.vue?vue&type=script&lang=js"
import style0 from "./DetalleOdtPaciente.vue?vue&type=style&index=0&id=74167546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports